import { useI18n } from '../i18n';
import type { AppLanguage } from '../i18n';
import { LanguagePickerIcon } from './LanguagePickerIcon';
import styles from './LanguageSwitcher.module.css';

/** Accessible names always in the target language (not translated). */
const NATIVE_NAMES: Record<AppLanguage, string> = {
  en: 'English',
  he: 'עברית',
};

type LanguageSwitcherProps = {
  variant?: 'default' | 'profileHub';
};

export function LanguageSwitcher({ variant = 'default' }: LanguageSwitcherProps) {
  const { language, languages, setLanguage, t } = useI18n();
  const groupClass = variant === 'profileHub' ? styles.groupProfileHub : styles.group;
  const optionClass = variant === 'profileHub' ? styles.optionProfileHub : styles.option;
  const iconSize = variant === 'profileHub' ? ('large' as const) : 'default' as const;

  return (
    <div className={groupClass} role="group" aria-label={t('language.pickerLabel')}>
      {languages.map((lang) => {
        const active = lang.code === language;
        const nativeName = NATIVE_NAMES[lang.code];
        return (
          <button
            key={lang.code}
            type="button"
            className={`${optionClass}${active ? ` ${styles.optionActive}` : ''}`}
            aria-pressed={active}
            aria-label={t('language.switchTo', { language: nativeName })}
            title={t('language.switchTo', { language: nativeName })}
            onClick={() => {
              if (!active) {
                setLanguage(lang.code);
              }
            }}
          >
            <LanguagePickerIcon icon={lang.pickerIcon} className={styles.icon} size={iconSize} />
          </button>
        );
      })}
    </div>
  );
}
